import {atom} from 'recoil';
import {LAYER_TYPE} from './constants';
import {CategoryData, PlanningData} from './types/subscibe';

interface LayerState {
  open: boolean;
  type?: LAYER_TYPE;
  data?: any;
  callback?: (result?: any) => void;
}

export const layerState = atom<LayerState>({
  key: 'layerState',
  default: {open: false},
});

export interface AuthInfoState {
  accountId: number; // 카카오 계정 아이디
  signup: boolean; // 가입 여부
}

export const authInfoState = atom<AuthInfoState>({
  key: 'authInfoState',
  default: {accountId: 0, signup: false},
});

export const planningListState = atom<PlanningData[] | null>({
  key: 'planningList',
  default: null,
});

export const categoryListState = atom<CategoryData[] | null>({
  key: 'categoryList',
  default: null,
});

export const tagFixedState = atom<boolean>({
  key: 'tagFixedState',
  default: false,
});

export const qrPopupState = atom<string>({
  key: 'qrPopupState',
  default: '',
});

export const terminationLayerDisplayedState = atom<boolean>({
  key: 'terminationLayerDisplayedState',
  default: false,
});
